import classNames from "classnames";
import * as React from "react";
import { IUIFieldProps, registerUIField } from "../../common";
import { FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";
import { defaultMapConfigs, defaultMapData, defaultTileUrl, IMapConfigProps, MapUI } from "../../map/MapUI";
import { executeAndBind, IDataSource, IDataSourceBinding } from "../../data-source-picker/datasource";
import { MapPropertyEditor } from "../../map/MapPropertyEditor";
import './MapUIField.scss'
import { hasValue, parseValue } from "../../../../util";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffectWithPolling } from "uxp/components";

interface IMapFieldProps {
	mapConfig: IMapConfigProps,
	source: IDataSourceBinding,
	refreshInterval: string
	locationText: string
	fontSize?: string;
	iconColor?: string;
	fieldLabel?: IFieldTitleProps
	mapWidth?: string
	mapHeight?: string


	// deprecated 
	// these are under map config
	latitude?: string;
	longitude?: string;
	markerColor?: string;
	zoom?: string;
	tileServer?: string;
	useDatasource?: boolean,
	datasources?: IDataSource[],
	latitudeField?: string,
	longitudeField?: string,
	locationField?: string,
	imageUrl?: string,
	width?: string,
	height?: string,
	minZoom?: string,
	maxZoom?: string
}

function getMapConfig(fieldProps: IMapFieldProps): IMapConfigProps {

	if (fieldProps.hasOwnProperty('mapConfig')) return fieldProps.mapConfig
	const { latitude, longitude, markerColor, zoom, tileServer, latitudeField, longitudeField, useDatasource, locationField, imageUrl, width, height, minZoom, maxZoom } = fieldProps

	const _temp = { ...defaultMapConfigs, showCenterMarker: true }
	if (useDatasource) {
		if (hasValue(latitudeField)) _temp.initialY = latitudeField
		if (hasValue(longitudeField)) _temp.initialX = longitudeField
	}
	else {
		if (hasValue(latitude)) _temp.initialY = latitude
		if (hasValue(longitude)) _temp.initialX = longitude
	}

	if (hasValue(imageUrl)) {
		_temp.mapTileSource.mode = 'image'
		_temp.mapTileSource.imageUrl = imageUrl
		if (hasValue(width)) _temp.mapTileSource.width = width
		if (hasValue(height)) _temp.mapTileSource.height = height
	}
	else {
		_temp.mapTileSource.mode = 'tile'
		_temp.mapTileSource.tileUrl = defaultTileUrl
		if (hasValue(tileServer)) _temp.mapTileSource.tileUrl = tileServer
	}

	if (hasValue(markerColor)) _temp.defaultMarkerColor = markerColor
	if (hasValue(zoom, true, true)) _temp.initialZoom = zoom
	if (hasValue(minZoom, true, true)) _temp.minZoom = minZoom
	if (hasValue(maxZoom, true, true)) _temp.maxZoom = maxZoom

	return _temp
}

export const Field: React.FunctionComponent<IUIFieldProps<IMapFieldProps>> = (props) => {

	const { mode, designer, uxpContext, contextData, fieldProps } = props

	const mapConfig = { ...defaultMapConfigs, ...getMapConfig(fieldProps) }
	const [mapData, setMapData] = React.useState<any[]>([])
	const isInThumbnailMode = () => designer && (designer.mode == 'thumbnail')

	useEffectWithPolling(uxpContext, "mapData", Number(fieldProps?.refreshInterval) || 6000, async () => {
		if (isInThumbnailMode()) {
			setMapData(defaultMapData)
			return;
		}

		if (!fieldProps?.source) {
			setMapData([])
			return;
		}

		executeAndBind(uxpContext, fieldProps?.source, props?.uiProps?.datasources || [], {})
			.then(res => {
				if (res) {
					setMapData(res)
				} else {
					setMapData([])
				}
			})
	}, [designer]);

	const styles: React.CSSProperties = {
		width: parseValue(fieldProps?.mapWidth || '100%', contextData),
		height: parseValue(fieldProps?.mapHeight || '150px', contextData)
	}

	const footerStyles: React.CSSProperties = {
		fontSize: parseValue(fieldProps?.fontSize || '14px', contextData),
		color: parseValue(fieldProps?.iconColor || '#424242', contextData)
	}

	return (
		<div className={classNames('ui-field-map-ui ui-field', props.mode)} >
			<FieldTitle {...fieldProps?.fieldLabel || {}} />

			<div className="ui-field-map-ui-map-container" style={styles} >
				<MapUI
					uxpContext={uxpContext}
					designer={designer}
					contextData={contextData}
					mapConfig={mapConfig}
					mapData={mapData}
				/>
			</div>
			{(hasValue(fieldProps?.locationText) || !fieldProps?.useDatasource) ?
				<div className='ui-field-map-ui-footer' style={footerStyles} >
					<div className='footer-icon'>
						<FontAwesomeIcon icon={'map-marker'}
						/>
					</div>
					<div className='footer-label'>
						{parseValue(fieldProps?.locationText || '', contextData)}
					</div>
				</div>
				: null}
		</div >
	)
}


registerUIField({
	id: 'map-ui',
	description: 'Map Location',
	field: Field,
	propertyEditor: MapPropertyEditor,
	defaultProps: {
		source: null,
		mapConfig: defaultMapConfigs,
		refreshInterval: '2000',
		fieldLabel: {
			label: '',
		},
		locationText: '',
		iconColor: '#424242',
		fontSize: '14px'
	},
	type: 'position'

});


